import { ActionIcon, Group, MantineColor, Text } from '@mantine/core';
import { IconMinus, IconPlus, IconTrash } from '@tabler/icons-react';

interface CounterProps {
  value: number;
  min?: number;
  max?: number;
  tempId: string;
  onChange: (newCount: number, tempId: string) => void;
}

const Counter = ({ value, max = Infinity, onChange, tempId }: CounterProps) => {
  const buttonBgColor: MantineColor = 'brand.8';
  const buttonRadius: string = 'md';

  const handleCountChange = (newCount: number) => {
    onChange(newCount, tempId);
  };

  const isTrash = value === 1;

  return (
    <Group justify="space-between" gap="sm">
      <ActionIcon
        variant="filled"
        color={buttonBgColor}
        radius={buttonRadius}
        disabled={max === value}
        onClick={(e) => {
          e.stopPropagation();
          handleCountChange(value + 1);
        }}
        id="add_to_basket_plus"
      >
        <IconPlus size="1rem" />
      </ActionIcon>

      <Text>{value}</Text>

      <ActionIcon
        variant="default"
        color={buttonBgColor}
        onClick={(e) => {
          e.stopPropagation();
          handleCountChange(value - 1);
        }}
        radius={buttonRadius}
        id="add_to_basket_minutes"
      >
        {isTrash ? <IconTrash size="1rem" /> : <IconMinus size="1rem" />}
      </ActionIcon>
    </Group>
  );
};

export default Counter;
